// eslint-disable-next-line max-len
const HUNDRED_BRICKS_PLATFORM_SECTION_MODELS = {
    list: 'list',
    grid: 'grid'
};
export default HUNDRED_BRICKS_PLATFORM_SECTION_MODELS;
